import React from 'react';
import { ArrowRightCircleIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { organizeList } from '../../data/content';
export function NotTheory() {
  return <section className="w-full bg-navy-deep px-5 py-16 text-white sm:py-20" data-id="element-213" data-mp="2rmfwkbrleev5">
      <div className="mx-auto max-w-3xl" data-id="element-214" data-mp="2wkzjofhx9wp3">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight sm:text-4xl" data-id="element-215" data-mp="2wjxwxdrjnlrj">
          This Is <span className="text-accent" data-id="element-216" data-mp="2ikf21mnqu6x6">Not</span> Another Theoretical Motor Development Ebook
        </h2>
        <p className="mt-5 text-center text-lg text-white/80" data-id="element-217" data-mp="2nlvy94va957f">
          You don't need hundreds of pages of disconnected explanations when your immediate challenge is organizing a case. The Pediatric Motor Planning Blueprint™ is built around practical professional deliverables.
        </p>
        <p className="mt-8 font-semibold text-brand-soft" data-id="element-218" data-mp="6wyuzrqxc0e6">Instead of simply reading about motor planning, you'll have tools to organize:</p>
        <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-219" data-mp="bse4k7hwfa4s">
          {organizeList.map(t => <li key={t} className="flex items-center gap-3 rounded-xl bg-navy-mid p-4 font-semibold" data-id="element-220" data-mp="22r47wnkt3jax">
              <ArrowRightCircleIcon className="h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-221" data-mp="2hfqyxmjspzhz" />
              {t}
            </li>)}
        </ul>
        <p className="mt-10 text-center font-display text-xl font-extrabold" data-id="element-222" data-mp="2chfll1ual6v0">
          Less Guesswork in Your Planning Process. More Structure in Your Documentation.
        </p>
        <SectionCTA label="Access My Blueprint" dark data-id="element-223" data-mp="1jta02cvezdu4" />
      </div>
    </section>;
}